// extracted by mini-css-extract-plugin
export default {"team":"Team_team__iTjPG","card":"Team_card__-BRVy"};